module.exports = __webpack_public_path__ + "media/svg-new/icon-humanas-31254e94.svg";